module.exports = __webpack_public_path__ + "img/doc.aca4d8b3.png";